import React from 'react';
import { Stack as MUIStack, StackProps as MUIStackProps } from '@mui/material';
export const Stack = (props: MUIStackProps) => {
  return <MUIStack {...props} />;
};
